import { PREVIEW_TRANSFER } from "../../constants";

export function dataTransferPreview(previewAction,phoneList,acdList,agentList) {
    return {
      type: PREVIEW_TRANSFER.DATA_CALL_PREVIEW,
      previewAction: previewAction,
      phoneList: phoneList,
      acdList: acdList,
      agentList: agentList
    };
}

export function onAcceptedTransfer(value){
  return{
    type: PREVIEW_TRANSFER.ON_RESPONSE_TRANSFER,
    isAccepted: value
  };
}

export function showAlert(){
  return{
    type: PREVIEW_TRANSFER.SHOW_ALERT
  };
}

export function showPreviewData(show){
  return{
    type: PREVIEW_TRANSFER.SHOW_PREVIEW_DATA,
    show: show
  };
}

export function setAgentList(agentList){
  return{
    type: PREVIEW_TRANSFER.SET_AGENT_LIST,
    agentList: agentList
  };
}

export function setTransferInProgress(flag){
  return{
    type: PREVIEW_TRANSFER.TRANSFER_IN_PROGRESS,
    flag: flag
  };
}

export function setUnnasignByXfer(flag){
  return{
    type: PREVIEW_TRANSFER.UNNASIGN_BY_XFER,
    flag: flag
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/A_preview_transfer.js